import { useQuery } from "@tanstack/react-query";
export const createParticipantsQueries = (requests, queryClient) => ({
    useListParticipants: (params, options = {}) => useQuery({
        queryKey: ["participants", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listParticipants(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map